(function () {
	const header = document.querySelector(
		'.wp-block-gino0o0o-auto-hide-header'
	);
	if (!header) return;

	const hideDelay = parseInt(header.dataset.ahhHideDelay, 10) || 100;
	const showThreshold = parseInt(header.dataset.ahhShowThreshold, 10) || 10;

	function getAdminBarHeight() {
		const raw = getComputedStyle(document.documentElement)
			.getPropertyValue('--wp-admin--admin-bar--height')
			.trim();
		return raw ? parseInt(raw, 10) : 0;
	}

	function applyFixedPosition() {
		Object.assign(header.style, {
			position: 'fixed',
			top: `${getAdminBarHeight()}px`,
			left: '0',
			right: '0',
		});
	}

	function syncPadding() {
		document.body.style.paddingTop =
			header.offsetHeight + getAdminBarHeight() + 'px';
	}

	applyFixedPosition();
	syncPadding();
	window.addEventListener(
		'resize',
		() => {
			applyFixedPosition(); // top cambia da 32px a 46px su mobile
			syncPadding();
		},
		{ passive: true }
	);

	// Adatta top quando la admin bar entra/esce dal viewport
	const adminBar = document.getElementById('wpadminbar');
	if (adminBar) {
		const observer = new IntersectionObserver(
			([entry]) => {
				header.style.top = entry.isIntersecting
					? `${getAdminBarHeight()}px`
					: '0';
			},
			{ threshold: 0 }
		);
		observer.observe(adminBar);
	}

	let lastScrollY = window.scrollY;
	let ticking = false;
	let hideTimer = null;

	function show() {
		syncPadding();
		clearTimeout(hideTimer);
		header.classList.remove('is-hidden');
	}

	function hide() {
		clearTimeout(hideTimer);
		hideTimer = setTimeout(() => {
			header.classList.add('is-hidden');
		}, hideDelay);
	}

	window.addEventListener(
		'scroll',
		() => {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(() => {
				const current = window.scrollY;
				const diff = lastScrollY - current;

				if (current <= 0) show();
				else if (diff > showThreshold) show();
				else if (diff < 0) hide();

				lastScrollY = current;
				ticking = false;
			});
		},
		{ passive: true }
	);
})();
